import { useCallback } from 'react'

export default ({ onChange, field, selectStep }) => {
  const handleChangeOrder = useCallback((typePath, items, oldIndex, newIndex) => {
    const target = `values[${field}].${typePath}`
    onChange({
      target: {
        value: items,
        name: target,
      },
    },
    (model, modifyUtils) => modifyUtils.swapErrors(
      model,
      `values[${field}].${typePath}[${oldIndex}]`,
      `values[${field}].${typePath}[${newIndex}]`,
    ))
    selectStep(`${typePath}[${newIndex}]`)
  }, [field, onChange, selectStep])
  return handleChangeOrder
}
